const SEARCH_SCREEN = 'terminal.search';
const START_SCREEN = 'terminal.start';
const GUIDE_SCREEN = 'terminal.guide';
const DESKTOP_START_SCREEN = 'web.start';
const MOBILE_ROOT = 'mobile.root';
const MOBILE_GUIDE = 'mobile.guide';
const MOBILE_CARE = 'mobile.care';
const MOBILE_SERVICES = 'mobile.services';
const MOBILE_SERVICE = 'mobile.service';
const MOBILE_SEARCHBAR = 'mobile.searchbar';
const TERMINAL_START = 'terminal.start';
const WEB_START = 'web.start';
const WEB_SERVICE = 'web.service';
const WEB_GUIDE = 'web.guide';
const WEB_ROOT = 'web.root';

const TYPES = {
    CARE: 'care'
};

export {
    TYPES,
    WEB_ROOT,
    WEB_GUIDE,
    WEB_START,
    MOBILE_ROOT,
    MOBILE_CARE,
    WEB_SERVICE,
    GUIDE_SCREEN,
    START_SCREEN,
    MOBILE_GUIDE,
    SEARCH_SCREEN,
    MOBILE_SERVICE,
    TERMINAL_START,
    MOBILE_SERVICES,
    MOBILE_SEARCHBAR,
    DESKTOP_START_SCREEN
};
